import React from 'react';
import styles from '../image/image.module.scss';
import { ElementDto } from 'api';
import { EditControlsType, SaveType } from 'modules/course/course.types';
import { ActionTypes } from 'modules/course/state/actions/course/types';
import { FileEdit } from './fileEdit';
import { FileView } from './fileView';
import { useClassName } from 'hooks/use-class-name';

const Wrapper = ({
	children,
	userCanEdit,
}: {
	children: React.ReactNode;
	userCanEdit?: boolean;
}) => {
	const classNames = useClassName(
		styles.text,
		userCanEdit && styles.editable,
	);

	return <div className={classNames}>{children}</div>;
};

interface IFile {
	chapterId: string;
	pageId: string;
	element: ElementDto;
	editControls: EditControlsType;
	save: SaveType;
	changeElement: ActionTypes['changeElement'];
	deleteElement: ActionTypes['deleteElement'];
}

export function FileComponent({
	chapterId,
	pageId,
	element,
	editControls,
	save,
	changeElement,
	deleteElement,
}: IFile) {
	const { setEditMode, leaveEditMode, editMode, userCanEdit } = editControls(
		element.id,
	);

	const handleChangeElement = (content: string) => {
		changeElement(chapterId, pageId, element.id, content);
	};

	const handleDeleteElement = () => {
		deleteElement(chapterId, pageId, element.id);
		save(element.id);
	};

	const handleSetEditMode = () => setEditMode(element.id);

	if (editMode) {
		return (
			<Wrapper>
				<FileEdit
					name={element.id}
					element={element}
					changeElement={handleChangeElement}
					deleteElement={handleDeleteElement}
					leaveEditMode={leaveEditMode}
					save={save}
					withDescription
				/>
			</Wrapper>
		);
	}

	return (
		<Wrapper userCanEdit={userCanEdit}>
			<FileView
				userCanEdit={userCanEdit}
				setEditMode={handleSetEditMode}
				element={element}
			/>
		</Wrapper>
	);
}
